<template>
  <ActListBox
    :api="postActivityList"
    :title="$t('new.text72')"
    :params="params" />
</template>
<script>
import { postActivityList } from '@/api/user'
import ActListBox from '@/components/ActListBox.vue'

export default {
  name: 'UserVoteList',
  components: { ActListBox },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  data() {
    return {
      postActivityList,
      params: { type: 12 }
    }
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/views/user/votelist.vue